var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner",style:({
    backgroundImage:
      'url(' + require('@/assets/images/banners/home-banner.png') + ')'
  })},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"banner__text"},[_vm._v("List or rent tools")]),_c('search-bar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }